/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { PermissionError } from '../error/PermissionError';
import { useIsAuthorized } from './useIsAuthorized';

export const IsAuthorized = ({ children }) => {
  const isAuthorized = useIsAuthorized();

  if (!isAuthorized) {
    throw new PermissionError();
  }

  return children;
};
